import classNames from 'classnames';

import { DropdownProvider } from '../../navbarElement/DropdownProvider';
import * as styles from '../Navbar.css';
import type {
  NavbarMenuItemV2ButtonElementProps,
  NavbarMenuItemV2ElementProps,
  NavbarMenuItemV2LinkElementProps,
} from './NavbarMenuItem.type';
import {
  NavbarMenuItemDropdown,
  NavbarMenuItemLink,
  NavbarMenuItemLogo,
  NavbarMenuItemSearch,
  NavbarMenuItemUserButton,
} from './components';

export function NavbarMenuItemV2(
  props: NavbarMenuItemV2ElementProps & {
    controlbyselected: boolean | string;
    selected: boolean;
  },
) {
  const { element, children, attributes } = props;
  const { type, showOnMobile } = element.attrs || {};

  const shouldRenderDropdownSeparatelyForEditor =
    attributes?.['data-should-render-dropdown-separately-for-editor'] !== undefined;

  const isEditorViewportDesktop = attributes?.['data-viewport'] === 'desktop';

  const wrapperClassName = classNames({
    'hidden md:flex': showOnMobile === false,
    'flex items-center': shouldRenderDropdownSeparatelyForEditor && isEditorViewportDesktop,
  });

  if (type === 'link' || type === 'button') {
    return (
      <div className={wrapperClassName}>
        <NavbarMenuItemLink {...(props as NavbarMenuItemV2LinkElementProps | NavbarMenuItemV2ButtonElementProps)}>
          {props.children}
          <div className={styles.navbarItemSeparatorV2} />
        </NavbarMenuItemLink>
      </div>
    );
  }
  if (type === 'user_button') {
    return (
      <div className={wrapperClassName}>
        <DropdownProvider>
          <NavbarMenuItemUserButton {...props}>
            {children}
            {element?.attrs?.type === 'user_button' && element?.attrs?.style === 'button' && (
              <div className={styles.navbarItemSeparatorV2} />
            )}
          </NavbarMenuItemUserButton>
        </DropdownProvider>
      </div>
    );
  }
  if (type === 'search') {
    return (
      <div className={wrapperClassName}>
        <NavbarMenuItemSearch {...props}>
          <div className={styles.navbarItemSeparatorV2} />
        </NavbarMenuItemSearch>
      </div>
    );
  }
  if (type === 'logo') {
    return (
      <div className={wrapperClassName}>
        <NavbarMenuItemLogo {...props}>
          {children}
          <div className={styles.navbarItemSeparatorV2} />
        </NavbarMenuItemLogo>
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      {shouldRenderDropdownSeparatelyForEditor ? (
        children
      ) : (
        <DropdownProvider>
          <NavbarMenuItemDropdown {...props}>
            {children}
            {/* Separator is inside the NavbarMenuItemDropdown component */}
          </NavbarMenuItemDropdown>
        </DropdownProvider>
      )}
    </div>
  );
}
